import { Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { TunnelStressAreaDto } from 'src/app/server-api/models';
import { TunnelStressAreaControllerService } from 'src/app/server-api/services';
import { DetailComponent } from 'src/app/utils-flc/detail/detail.component';
import { IStressAreaFormGroup } from './IStressAreaFormGroup';

@Component({
  selector: 'app-stress-area',
  templateUrl: './stress-area.component.html',
  styleUrls: ['./stress-area.component.css']
})
export class StressAreaComponent extends DetailComponent {
  stressArea: TunnelStressAreaDto;

  //override the id coming from route params by id coming from dialog
  @Input() override id: string;

  constructor(
    public override translate: TranslateService,
    private areaService: TunnelStressAreaControllerService,
    public override sidenavService: SideNavService,
    public override router: Router,
    private formBuilder: UntypedFormBuilder
  ) {
    super(translate, sidenavService, router);
  }

  override initItem(): void {
    super.initItem();
    //init an empty dto and set the invisible fields
    this.stressArea = {} as any as TunnelStressAreaDto;

    this.initForm();
    this.columnsVisible.set('id', false);
  }

  override getItem(request) {
    super.getItem(request);

   this.areaService.getTunnelStressArea(request).subscribe((data: TunnelStressAreaDto) => {
      this.stressArea = data;
      this.name = data.id;

      //to fix to many digits from server sometimes
      this.stressArea.chainage = Math.round(this.stressArea.chainage * 1000) / 1000;
      this.stressArea.depthSoil = Math.round(this.stressArea.depthSoil * 1000) / 1000;
      this.stressArea.depthDisturbance = Math.round(this.stressArea.depthDisturbance * 1000) / 1000;
      this.stressArea.depthGravel = Math.round(this.stressArea.depthGravel * 1000) / 1000;
      this.stressArea.depthTunnelPlan = Math.round(this.stressArea.depthTunnelPlan * 1000) / 1000;
      this.stressArea.kDistSoil = Math.round(this.stressArea.kDistSoil * 1000) / 1000;
      this.stressArea.kSubSoil = Math.round(this.stressArea.kSubSoil * 1000) / 1000;
      this.stressArea.longitudinal = Math.round(this.stressArea.longitudinal * 1000) / 1000;
      this.stressArea.transversal = Math.round(this.stressArea.transversal * 1000) / 1000;
      this.stressArea.springConstant = Math.round(this.stressArea.springConstant * 100000) / 100000;
      this.stressArea.length = Math.round(this.stressArea.length * 1000) / 1000;
      this.stressArea.width = Math.round(this.stressArea.width * 1000) / 1000;
      this.stressArea.stressPatternAvg = Math.round(this.stressArea.stressPatternAvg * 1000) / 1000;

      this.stressArea.deformationReal  = Math.round(this.stressArea.deformationReal * 1000) / 1000;
      this.stressArea.depthTunnelConstr = Math.round(this.stressArea.depthTunnelConstr * 1000) / 1000;
      this.stressArea.gravelAvgAreaPerct = Math.round(this.stressArea.gravelAvgAreaPerct * 1000) / 1000;
      this.stressArea.gravelCalcAreaPerct = Math.round(this.stressArea.gravelCalcAreaPerct * 1000) / 1000;
      this.stressArea.gravelMeasAreaPerct = Math.round(this.stressArea.gravelMeasAreaPerct * 1000) / 1000;
      this.stressArea.reactionRotationReal = Math.round(this.stressArea.reactionRotationReal * 1000) / 1000;
      this.stressArea.reactionUniformReal = Math.round(this.stressArea.reactionUniformReal * 1000) / 1000;
      this.stressArea.rotMomentReal = Math.round(this.stressArea.rotMomentReal * 1000) / 1000;
      this.stressArea.settlement = Math.round(this.stressArea.settlement * 1000) / 1000;
      this.stressArea.springConstantWithoutGravelArea = Math.round(this.stressArea.springConstantWithoutGravelArea * 100000) / 100000;
      this.stressArea.verticalLoad = Math.round(this.stressArea.verticalLoad * 1000) / 1000;
      this.stressArea.transErrorLine = Math.round(this.stressArea.transErrorLine * 1000) / 1000;
      this.stressArea.longHardCenterErrorPerc = Math.round(this.stressArea.longHardCenterErrorPerc * 1000) / 1000;
      this.stressArea.longHardEdgeErrorPerc = Math.round(this.stressArea.longHardEdgeErrorPerc * 1000) / 1000;
      this.stressArea.longOverallErrorPerc = Math.round(this.stressArea.longOverallErrorPerc * 1000) / 1000;
      this.stressArea.longTwistErrorPerc = Math.round(this.stressArea.longTwistErrorPerc * 1000) / 1000;

      this.initForm();
      this.detailForm.controls['id'].disable();

    });
  }

  override setForm() {
    //set visibility fields, set FormGroup and validators
    super.setForm();

    this.columnsVisible = new Map([
      ['id', false],
      ['area', true],
      ['created', true],
      ['lastModificationDate', true],
      ['calcStatus', true],
      ['calcStatusTrans', true],
      ['chainage', true],
      ['depthDisturbance', true],
      ['depthGravel', true],
      ['depthSoil', true],
      ['depthTunnelPlan', true],
      ['longitudinal', true],
      ['point', true],
      ['springConstant', true],
      ['surface', true],
      ['transversal', true],
      ['tunnelSection', true],
      ['kDistSoil', true],
      ['kSubSoil', true],
      ['width', true],
      ['length', true],
      ['stressPatternAvg', true],
      ['stressPatternLong', false],
      ['stressPatternTrans', false],
      ['comment', true],
      ['deformationReal', true],
      ['depthTunnelConstr', true],
      ['gravelAvgAreaPerct', true],
      ['gravelCalcAreaPerct', true],
      ['gravelMeasAreaPerct', true],
      ['reactionRotationReal', true],
      ['reactionUniformReal', true],
      ['rotMomentReal', true],
      ['settlement', true],
      ['springConstantWithoutGravelArea', true],
      ['verticalLoad', true],
      ['gravelSpacing', true],
      ['transErrorLine', true],
      ['longHardCenterErrorPerc', true],
      ['longHardEdgeErrorPerc', true],
      ['longOverallErrorPerc', true],
      ['longTwistErrorPerc', true]
      ]);

    this.detailForm = this.formBuilder.group({
      area: [{ value: '', disabled: true }],
      calcStatus: [{ value: '', disabled: true }],
      calcStatusTrans: [{ value: '', disabled: true }],
      chainage: [{ value: '', disabled: true }],
      created: [{ value: '', disabled: true }],
      depthDisturbance: [{ value: '', disabled: true }],
      depthGravel: [{ value: '', disabled: true }],
      depthSoil: [{ value: '', disabled: true }],
      depthTunnelPlan: [{ value: '', disabled: true }],
      id: [{ value: '', disabled: true }],
      lastModificationDate: [{ value: '', disabled: true }],
      longitudinal: [{ value: '', disabled: true }],
      point: [{ value: '', disabled: true }],
      springConstant: [{ value: '', disabled: true }],
      surface: [{ value: '', disabled: true }],
      transversal: [{ value: '', disabled: true }],
      tunnelSection: [{ value: '', disabled: true }],
      kDistSoil: [{ value: 0, disabled: true }],
      kSubSoil: [{ value: 0, disabled: true }],
      width: [{ value: 0, disabled: true }],
      length: [{ value: 0, disabled: true }],
      stressPatternAvg: [{ value: 0, disabled: true }],
      stressPaternLong: [{ value: 0, disabled: true }],
      stressPatternTrans: [{ value: 0, disabled: true }],
      comment: [{ value: '', disabled: true }],
      deformationReal: [{ value: 0, disabled: true }],
    depthTunnelConstr: [{ value: 0, disabled: true }],
    gravelAvgAreaPerct: [{ value: 0, disabled: true }],
    gravelCalcAreaPerct: [{ value: 0, disabled: true }],
    gravelMeasAreaPerct: [{ value: 0, disabled: true }],
    reactionRotationReal: [{ value: 0, disabled: true }],
    reactionUniformReal: [{ value: 0, disabled: true }],
    rotMomentReal: [{ value: 0, disabled: true }],
    settlement: [{ value: 0, disabled: true }],
    springConstantWithoutGravelArea: [{ value: 0, disabled: true }],
    verticalLoad: [{ value: 0, disabled: true }],
    gravelSpacing: [{ value: 0, disabled: true}],
    transErrorLine: [{ value: 0, disabled: true}],
    longHardCenterErrorPerc: [{ value: 0, disabled: true}],
    longHardEdgeErrorPerc: [{ value: 0, disabled: true}],
    longOverallErrorPerc: [{ value: 0, disabled: true}],
    longTwistErrorPerc: [{ value: 0, disabled: true}],
      }) as IStressAreaFormGroup;

    //patch value dto to formGroup
    this.detailForm.patchValue(this.stressArea);
  }

  override initForm() {
    super.initForm();
    this.initDialogDelete('stress-area.dialog_title');

    //set topmenu icon actions
    this.translate.get(['icon_refresh', 'icon_menu']).subscribe((translations: string[]) => {
      this.topMenuIcons = [
        {
          icon: 'refresh',
          title: translations['icon_refresh'],
          routerLink: null,
          clickMethod: 'refresh',
        }
      ];
    });
    this.setForm();
  }


  override saveOk() {
    super.saveOk();
    this.sidenavService.setLoading(false);
    //no save done
  }


  override delete() {
    super.delete();
    this.sidenavService.setLoading(false);
    //no delete done
  }

  getMaxPerc()
  {
    if (this.stressArea)
    {
      let max = Math.max(this.stressArea.transErrorLine, this.stressArea.longHardCenterErrorPerc, this.stressArea.longHardEdgeErrorPerc, this.stressArea.longOverallErrorPerc,   this.stressArea.longTwistErrorPerc);
      return Math.round(max * 1000) / 1000;
    }
    return 0;
  }
}



